import { z } from "zod";
import { CURRENCIES } from "@/constants";

export const documentValidationSchema = z
    .object({
        invoiceReceiptId: z
            .string()
            .regex(
                /^$|^[A-Z0-9\s-\/\\_~]+$/i,
                "Invoice ID can contain letters, numbers, spaces, dashes, slashes, underscores."
            )
            .optional(),

        vendorName: z
            .string({
                required_error: "Vendor name is required",
            })
            .min(1, "Vendor name is required"),

        currency: z.enum(
            CURRENCIES.map((c) => c.code) as [string, ...string[]],
            {
                errorMap: () => ({ message: "Please select a valid currency" }),
            }
        ),

        invoiceReceiptDate: z
            .string({
                required_error: "Invoice date is required",
            })
            .min(1, "Invoice date is required")
            .refine((date) => !isNaN(Date.parse(date)), "Invalid date format")
            .refine(
                (date) => new Date(date) <= new Date(),
                "Invoice date cannot be in the future"
            ),

        total: z.number({
            required_error: "Total amount is required for transaction records",
        }),

        tax: z
            .number({
                required_error:
                    "Tax amount is required and must be 0 or greater",
            })
            .min(0, "Tax amount cannot be negative"),
    })
    .refine(
        (data) => {
            // Only validate tax vs total relationship if total is positive
            if (data.total > 0) {
                return data.tax <= data.total;
            }
            return true;
        },
        {
            message:
                "Tax amount cannot exceed the total amount - please verify your calculations",
            path: ["tax"],
        }
    )
    .refine(
        (data) => {
            // Only validate tax percentage if total is positive
            if (data.total > 0) {
                return data.tax <= data.total * 0.5;
            }
            return true;
        },
        {
            message:
                "Tax amount seems unusually high (over 50% of total) - please verify this is correct",
            path: ["tax"],
        }
    );
